export default function image_lightbox() {
    const modal = document.createElement('div');
    modal.className = 'image-lightbox-modal';
    modal.innerHTML = `
        <div class="close-btn">&times;</div>
        <div class="slider-btn prev-btn">&#10094;</div>
        <div class="slider-btn next-btn">&#10095;</div>
        <div class="img-container">
            <img src="">
        </div>
    `;
    document.body.appendChild(modal);

    const modalImg = modal.querySelector('img');
    const closeBtn = modal.querySelector('.close-btn');
    const prevBtn = modal.querySelector('.prev-btn');
    const nextBtn = modal.querySelector('.next-btn');

    let currentGallery = [];
    let currentIndex = 0;

    const updateImage = () => {
        if (currentGallery.length > 0) {
            modalImg.src = currentGallery[currentIndex];
        }
    };

    const openModal = (index, gallery) => {
        currentGallery = gallery;
        currentIndex = index;
        updateImage();

        if (gallery.length <= 1) {
            prevBtn.style.display = 'none';
            nextBtn.style.display = 'none';
        } else {
            prevBtn.style.display = 'flex';
            nextBtn.style.display = 'flex';
        }

        modal.classList.add('active');
        document.body.style.overflow = 'hidden';
    };

    const closeModal = () => {
        modal.classList.remove('active');
        document.body.style.overflow = '';
        setTimeout(() => { modalImg.src = ''; }, 300);
    };

    const nextImage = (e) => {
        if (e) e.stopPropagation();
        currentIndex = (currentIndex + 1) % currentGallery.length;
        updateImage();
    };

    const prevImage = (e) => {
        if (e) e.stopPropagation();
        currentIndex = (currentIndex - 1 + currentGallery.length) % currentGallery.length;
        updateImage();
    };

    const blocks = document.querySelectorAll('.horizontal_tabs_block');

    blocks.forEach(block => {
        const triggers = Array.from(block.querySelectorAll('.lightbox-trigger'));
        const galleryUrls = triggers.map(t => t.getAttribute('data-full-img'));

        triggers.forEach((trigger, index) => {
            trigger.addEventListener('click', () => {
                openModal(index, galleryUrls);
            });
        });
    });

    closeBtn.addEventListener('click', closeModal);
    prevBtn.addEventListener('click', prevImage);
    nextBtn.addEventListener('click', nextImage);

    modal.addEventListener('click', (e) => {
        if (e.target === modal || e.target.classList.contains('img-container')) {
            closeModal();
        }
    });

    document.addEventListener('keydown', (e) => {
        if (!modal.classList.contains('active')) return;

        if (e.key === 'Escape') closeModal();
        if (e.key === 'ArrowRight') nextImage();
        if (e.key === 'ArrowLeft') prevImage();
    });
}